export type SlideNormPoint = { x: number; y: number };

function frac4(n: number): number {
  return Math.round(n * 10000) / 10000;
}

/** 드래그 시작 꼭짓점 + 누적 델타. 라이브 점에 누적 델타를 더하면 매 프레임 가속된다. */
export function translatePolylinePoints(
  points: SlideNormPoint[],
  dx: number,
  dy: number
): SlideNormPoint[] {
  return points.map((p) => ({ x: frac4(p.x + dx), y: frac4(p.y + dy) }));
}

/** 시작 박스 기준 상대 위치를 새 박스에 투영. 리사이즈도 시작 꼭짓점을 써야 한다. */
export function scalePolylinePointsFromBox(
  points: SlideNormPoint[],
  from: { x: number; y: number; w: number; h: number },
  to: { x: number; y: number; w: number; h: number }
): SlideNormPoint[] {
  const ow = Math.max(1e-6, from.w);
  const oh = Math.max(1e-6, from.h);
  return points.map((p) => ({
    x: frac4(to.x + ((p.x - from.x) / ow) * to.w),
    y: frac4(to.y + ((p.y - from.y) / oh) * to.h),
  }));
}
